<template>
  <b-container>
    <div class="mt-4 d-flex justify-content-between">
      <back-arrow :bilan-type="bilanType"
                  :params="{operationId: operationId, currentSection:4, operationBilanId:operationBilanId}"
                  :sub-title-ope="this.operationName"
                  :title="$t('operation.bilan.Assurances')"
                  route-back="OperationShow"/>

      <card-total-component
        :custom-class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`"
        :value="prixHT | formatEuro"
        class="ml-auto col-md-2"
        title="operation.totalht"/>

      <card-total-component
        :custom-class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`"
        :value="totalTVA | formatEuro"
        class="ml-2 col-md-2"
        title="operation.totaltva"/>

      <card-total-component
        :custom-class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`"
        :value="totalTTC | formatEuro"
        class="ml-2 col-md-2"
        title="operation.totalttc"/>

    </div>

    <div class="row justify-content-between mt-3 mb-4">
      <div class="col-md-12">
        <div class="white-card mr-0 p-3">
          <div class="d-flex mb-0 align-items-center justify-content-end">
            <help-icon class="mr-2" size="18"/>
            <span>{{ $t('info.none.tva.insurance') }}</span>
          </div>

          <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

            <template v-for="operationCharge in operationCharges">
              <operation-charge-component
                :is-h-t="isHT"
                :operation-charge="operationCharge"
                @didChangeValue="emitChangeValue"
                @removedOperationCharge="removedOperationCharge"/>
            </template>

            <div class="row mt-3">
              <div class="col-md-12">
              <span class="bold-text addLink"
                    @click="addOperationCharge()"> + {{ $t('Add') }} {{ $t(typeFrais.text) }}</span>
              </div>
            </div>

            <div class="d-flex justify-content-end">
              <b-button type="submit" variant="primary">{{ $t('Save') }}</b-button>
            </div>

          </b-form>
        </div>
      </div>

      <add-operation-charge-modal
        :type-frais="typeFrais"
        :operation-id="operationId"
        :existing-pourcentage-prix-revient-count="existingPourcentagePrixRevientCount"
        :is-h-t="isHT"
        @didAddOperationCharge="didAddOperationCharge"/>

    </div>
  </b-container>
</template>

<script>

import CardTotalComponent from '../../operation/components/CardTotalComponent.vue'
import BackArrow from '../../../components/b122/BackArrow.vue'
import OperationChargeComponent from '../components/OperationChargeComponent.vue'
import AddOperationChargeModal from '../components/AddOperationChargeModal.vue'
import api from '../../../services/api'

export default {
  name: 'OperationBilanInsurancesEdit',

  components: {
    CardTotalComponent,
    BackArrow,
    OperationChargeComponent,
    AddOperationChargeModal
  },

  data () {
    return {
      totalTTC: '-',
      totalTVA: '-',
      prixHT: '-',
      operationName: null,
      operationId: this.$route.params.operationId,
      operationBilanId: this.$route.params.operationBilanId,
      simulationId: this.$route.params.simulationId,
      operationCharges: [],
      operationChargesIdsToRemove: [],
      typeFrais: null,
      bilanType: null,
      isHT: false
    }
  },

  async mounted () {
    await this.fetchData()
  },

  methods: {
    async fetchData () {
      await this.getOperation()
      await this.getOperationBilanId()
      await this.getOperationBilanType()
      await this.getTotalOfBilan()
      await this.getTypeFrais()
      await this.getOperationCharges()
    },

    async getOperation () {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.isHT = response.data.isHT
          })
      }
    },

    async getOperationBilanId () {
      await api
        .get(`/operation/getOperationBilanId/${this.operationId}`)
        .then(response => {
          this.operationBilanId = response.data.id
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 4,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getOperationBilanType () {
      this.isLoading = true
      api
        .get(`/operationBilan/getOperationBilanType/${this.operationBilanId}`)
        .then(response => {
          this.bilanType = response.data.bilanType
          this.operationName = response.data.operationName
        })
    },

    async getTypeFrais () {
      await api
        .get(`/operationCharge/getTypeInsurances`)
        .then(response => {
          this.typeFrais = response.data
        })
    },

    async getTotalOfBilan () {
      await api
        .get(`/operationBilan/getTotalOfBilan/${this.operationId}`)
        .then(response => {
          this.totalTTC = response.data[3].prixTTC
          this.totalTVA = response.data[3].TVA
          this.prixHT = response.data[3].prixHT
        })
    },

    async getOperationCharges () {
      if (this.operationId != null) {
        await api
          .get(`/operationCharge/getAllInsurancesForOperation/${this.operationId}`)
          .then(response => {
            this.operationCharges = (response.data || []).map(ch => ({
              ...ch,
              uniteCharge: ch.uniteCharge || ch.uniteChargeEnum || null,
              pourcentage: ch.pourcentage != null ? ch.pourcentage : null
            }))
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 4,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async emitChangeValue () {
      this.$emit('didChangeValue')
    },

    addOperationCharge () {
      this.$bvModal.show('add-operation-charge-modal')
    },

    didAddOperationCharge (operationCharge) {
      this.operationCharges.push(operationCharge)
    },

    removedOperationCharge (operationCharge) {
      if (operationCharge.id) {
        this.operationChargesIdsToRemove.push(operationCharge.id)
      }
      this.operationCharges.splice(this.operationCharges.indexOf(operationCharge), 1)
    },

    back () {
      this.$confirm(this.$i18n.t('Back.confirm').toString()).then(() => {
        this.$emit('didBack')
      })
    },

    async onSubmit () {
      await this.createOrUpdateOperationCharges()
      await this.deleteOperationCharges()
      await this.editOperationBilan()
      await this.getTotalOfBilan()
      await this.generateMonthlyCharges()
      this.$router.push({
        name: 'OperationShow',
        params: {
          operationId: this.operationId,
          currentSection: 4
        }
      })
    },

    async generateMonthlyCharges () {
      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async createOrUpdateOperationCharges () {
      for (const operationCharge of this.operationCharges) {
        let data = new FormData()
        data.append('operationId', this.operationId)
        data.append('name', operationCharge.name)
        data.append('prixTTC', operationCharge.prixTTC)

        if (operationCharge.manuallyEdited && this.isPercentageModeCharge(operationCharge)) {
          data.append('uniteCharge', 'UNITAIRE')
          data.append('convertedFromPercentage', 'true')
        } else {
          if (operationCharge.uniteCharge) {
            data.append('uniteCharge', operationCharge.uniteCharge)
          }
          if (operationCharge.pourcentage != null && operationCharge.pourcentage !== '') {
            data.append('pourcentage', operationCharge.pourcentage)
          }
        }

        data.append('typeFrais', operationCharge.typeFrais.value)

        let url = 'operationCharge'
        if (operationCharge.id) {
          url = '/operationCharge/' + operationCharge.id
        }

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then(() => {
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 4,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async deleteOperationCharges () {
      for (const operationChargeId of this.operationChargesIdsToRemove) {
        await api
          .delete(`/operationCharge/${operationChargeId}`)
      }
    },

    async editOperationBilan () {
      let data = new FormData()
      data.append('assurancesDone', true)

      api({
        method: 'POST',
        url: '/operationBilan/' + this.operationBilanId,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    isPercentageModeCharge (operationCharge) {
      return operationCharge && (
        operationCharge.uniteCharge === 'POURCENTAGE_PRIX_REVIENT' ||
        operationCharge.uniteCharge === 'POURCENTAGE_COUT_TRAVAUX' ||
        operationCharge.uniteCharge === 'POURCENTAGE_COUT_TRAVAUX_HONORAIRE' ||
        operationCharge.uniteChargeEnum === 'POURCENTAGE_PRIX_REVIENT' ||
        operationCharge.uniteChargeEnum === 'POURCENTAGE_COUT_TRAVAUX' ||
        operationCharge.uniteChargeEnum === 'POURCENTAGE_COUT_TRAVAUX_HONORAIRE'
      )
    }
  },
  computed: {
    existingPourcentagePrixRevientCount () {
      try {
        return (this.operationCharges || []).filter(c => c && (c.uniteCharge === 'POURCENTAGE_PRIX_REVIENT' || c.uniteChargeEnum === 'POURCENTAGE_PRIX_REVIENT')).length
      } catch (e) {
        return 0
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/bilanEditSteps/OperationBilanInsurancesEdit.vue